import 'react/jsx-runtime';
import { createContext } from 'react';
import '../../../services/i18nService.js';
import '@optimizely/optimizely-sdk';
import '@sentry/browser';
import '../../../config/consts.js';

const CheckoutContext = createContext({});

export { CheckoutContext };
//# sourceMappingURL=CheckoutContextProvider.js.map
